import { render } from "./add-user.vue?vue&type=template&id=472fcdaf"
import script from "./add-user.vue?vue&type=script&lang=js"
export * from "./add-user.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tap-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__